import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import subscriptionsSelector from 'selectors/page/autoReplenishment/subscriptions/subscriptionsSelector';
import ShippingAndPaymentInfoSelector from 'selectors/page/autoReplenishment/shippingAndPaymentInfo/shippingAndPaymentInfoSelector';

const { shippingAndPaymentInfoSelector } = ShippingAndPaymentInfoSelector;

/**
 * Provides subscription state and current payment data for the AutoReplenishment hub.
 */
export function useSubscriptions() {
    const allSubscriptions = useSelector(subscriptionsSelector);
    const currentSubscriptionPaymentData = useSelector(state => shippingAndPaymentInfoSelector(state)?.payment);

    const [currentSubscription, setCurrentSubscriptionState] = useState({});

    const setCurrentSubscription = useCallback(subscription => {
        setCurrentSubscriptionState({
            ...subscription,
            currentSku: {
                // Required for modals and analytics. Do not delete
                ...subscription.items?.[0],
                frequency: subscription.frequency,
                frequencyType: subscription.frequencyType
            }
        });
    }, []);

    const updateCurrentSubscription = useCallback(patch => {
        setCurrentSubscriptionState(prev => ({ ...prev, ...patch }));
    }, []);

    return {
        currentSubscriptionPaymentData,
        allSubscriptions,
        currentSubscription,
        setCurrentSubscription,
        updateCurrentSubscription
    };
}
